export default "__VITE_ASSET__C2xH8yj$__"